import { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../UI/Modal';

export default function AgenceManager() {
    const [agences, setAgences] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({ nom: '', ville: '', actif: true });

    useEffect(() => { loadAgences(); }, []);

    const loadAgences = async () => {
        try {
            const res = await api.get('/agences');
            setAgences(res.data.member || []);
        } catch (err) { console.error(err); }
    };

    const openCreate = () => {
        setSelected(null);
        setForm({ nom: '', ville: '', actif: true });
        setShowModal(true);
    };

    const openEdit = (agence) => {
        setSelected(agence);
        setForm({ nom: agence.nom || '', ville: agence.ville || '', actif: agence.actif ?? true });
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (selected) {
                await api.patch(`/agences/${selected.id}`, form, {
                    headers: { 'Content-Type': 'application/merge-patch+json' }
                });
            } else {
                await api.post('/agences', form, {
                    headers: { 'Content-Type': 'application/ld+json' }
                });
            }
            setShowModal(false);
            loadAgences();
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0 }}>Agences ({agences.length})</h3>
                <button onClick={openCreate} style={addButtonStyle}>
                    <i className="ti ti-plus" style={{ marginRight: '6px' }} />
                    Ajouter une agence
                </button>
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.07)' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                    <tr style={{ backgroundColor: '#f8fafc' }}>
                        <th style={thStyle}>Nom</th>
                        <th style={thStyle}>Ville</th>
                        <th style={thStyle}>Statut</th>
                        <th style={thStyle}>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {agences.map(a => (
                        <tr key={a.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                            <td style={{ ...tdStyle, fontWeight: '600' }}>{a.nom}</td>
                            <td style={tdStyle}>{a.ville || '—'}</td>
                            <td style={tdStyle}>
                                    <span style={{
                                        padding: '3px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: '600',
                                        backgroundColor: a.actif ? '#dcfce7' : '#fee2e2',
                                        color: a.actif ? '#16a34a' : '#dc2626',
                                    }}>
                                        {a.actif ? 'Active' : 'Inactive'}
                                    </span>
                            </td>
                            <td style={tdStyle}>
                                <button onClick={() => openEdit(a)} style={editButtonStyle} title="Modifier">
                                    <i className="ti ti-pencil" />
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <Modal title={selected ? 'Modifier l\'agence' : 'Nouvelle agence'} onClose={() => setShowModal(false)}>
                    <form onSubmit={handleSubmit}>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Nom *</label>
                            <input type="text" value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} style={inputStyle} required />
                        </div>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Ville</label>
                            <input type="text" value={form.ville} onChange={e => setForm({ ...form, ville: e.target.value })} style={inputStyle} />
                        </div>
                        <div style={{ ...fieldStyle, display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input type="checkbox" checked={form.actif} onChange={e => setForm({ ...form, actif: e.target.checked })} style={{ width: '16px', height: '16px' }} />
                            <label style={{ ...labelStyle, margin: 0 }}>Active</label>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                            <button type="button" onClick={() => setShowModal(false)} style={cancelButtonStyle}>Annuler</button>
                            <button type="submit" style={submitButtonStyle} disabled={loading}>
                                {loading ? 'Enregistrement...' : selected ? 'Modifier' : 'Créer'}
                            </button>
                        </div>
                    </form>
                </Modal>
            )}
        </div>
    );
}

const addButtonStyle = { padding: '8px 16px', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' };
const editButtonStyle = { padding: '4px 8px', backgroundColor: '#f0f2f5', border: 'none', borderRadius: '6px', cursor: 'pointer' };
const thStyle = { padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#888' };
const tdStyle = { padding: '12px 16px', fontSize: '14px', color: '#333' };
const fieldStyle = { marginBottom: '16px' };
const labelStyle = { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#444' };
const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
const cancelButtonStyle = { padding: '10px 20px', backgroundColor: '#f0f2f5', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' };
const submitButtonStyle = { padding: '10px 20px', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' };